<template>
  <div>
    <v-row no-gutters class="mb-2">
      <span class="body-2 font-weight-medium">Your Subscription Quote</span>
    </v-row>


    <div v-if="TYPE === 'SUBSCRIPTION'">
      <v-row no-gutters class="mb-4">
          <span class="body-2">This is your Annual Subscription price
            <span v-if="checkValidity && validCoupon" class="body-2 font-weight-medium">{{"including a " + COUPON.name + ". "}}</span>
            <span v-else class="body-2 font-weight-medium">including a 10% discount. </span>
            It is calculated by the population of your Council.
          </span>
      </v-row>
      <v-row no-gutters v-if="checkValidity && validCoupon" class="mb-4">
        <span class="body-2 success--text">Discount has been applied. Price shown includes this discount.</span>
      </v-row>
    </div>


    <div v-if="TYPE === 'TRIAL'">
      <v-row no-gutters class="mb-4">
        <span class="body-2">This is your Annual Subscription price. It is calculated by the population of your Council.</span>
      </v-row>
      <v-row no-gutters class="mb-4">
        <span class="body-2">If you choose to disable auto-renew before your trial ends, you will not be charged.</span>
      </v-row>
      <v-row no-gutters v-if="checkValidity && validCoupon" class="mb-4">
        <span class="body-2 success--text">Discount has been applied. Price shown includes this discount.</span>
      </v-row>
    </div>

    <v-row>
      <v-col>
        <span class="caption">Subtotal</span>
        <v-text-field outlined readonly dense filled hide-details
                      prefix="£"
                      :suffix="formatCurrency(parishSubtotal)"
        >
        </v-text-field>
      </v-col>
      <v-col>
        <span class="caption">VAT</span>
        <v-text-field outlined readonly dense filled hide-details
                      prefix="£"
                      :suffix="formatCurrency(parishVat)"
        >
        </v-text-field>
      </v-col>
      <v-col>
        <span class="caption">Total</span>
        <v-text-field outlined readonly dense filled hide-details
                      prefix="£"
                      :suffix="formatCurrency(parishTotal)"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row align="end">
      <v-col cols="4">
        <span class="caption">Got a discount code?</span>
        <v-text-field outlined dense hide-details
                      v-model="couponInput"
                      placeholder="Enter a discount code"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-btn depressed rounded
               color="#F2C953"
               width="150px"
               @click="applyCoupon()"
        >Apply
        </v-btn>
      </v-col>
    </v-row>

    <div v-if="hasApplied">
      <div v-if="validCoupon">
        <span class="caption success--text">{{ validMessage + " " }}</span>
        <span class="caption success--text"
              style="text-decoration: underline; cursor: pointer"
              @click="removeCoupon()">Click here to remove.
        </span>
      </div>
      <div v-else>
        <span class="caption error--text">{{validMessage}}</span>
      </div>
    </div>

    <v-row no-gutters class="mt-4">
      <span class="body-2">Click "Next" to continue the signup process.</span>
    </v-row>

  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "StepThree",
    components: {},
    props: {},
    data() {
      return {
        couponInput: '',
        validCoupon: false,
        validMessage: '',
        hasApplied: false,
      }
    },
    computed: {
      ...mapGetters({
        PARISH: 'GET_SELECTED_PARISH',
        TYPE: 'GET_SIGNUP_TYPE',
        COUPON: 'GET_ACTIVE_COUPON'
      }),
      parishSubtotal() {
        if (this.PARISH) {
          return this.PARISH.price - this.computedDiscount;
        }
      },
      parishVat() {
        if (this.PARISH) {
          return (this.parishSubtotal / 5);
        }
      },
      parishTotal() {
        if (this.PARISH) {
          return this.parishSubtotal + this.parishVat;
        }
      },
      computedDiscount() {
        if (this.checkValidity && this.validCoupon) {
          return (this.COUPON.percent_off / 100) * this.PARISH.price;
        } else {
          if (this.TYPE === 'SUBSCRIPTION') {
            return (this.PARISH.price / 10);
          } else {
            return 0;
          }
        }
      },
      checkValidity() {
        let coupon = this.$store.getters['GET_ACTIVE_COUPON'];

        if (coupon) {
          if (coupon.id) {
            if (coupon.metadata.restrictedto) {
              let restrictionArray = coupon.metadata.restrictedto.split(',');
              let valid = false;

              restrictionArray.forEach((restriction) => {
                restriction = restriction.replace('%', '');
                let regex = new RegExp(`^${restriction}`);

                console.log(regex);
                if (regex.test(this.PARISH.census_id)) {
                  valid = true;
                }
                console.log(valid);
              });

              if (valid) {
                this.validCoupon = true;
                this.validMessage = 'Successfully added coupon.';
                return true;
              } else {
                this.validCoupon = false;
                this.validMessage = 'Sorry, this code is not available for this local council.';
                this.$store.commit('SET_ACTIVE_COUPON', null);
                return true;
              }
            } else {
              this.validCoupon = true;
              this.validMessage = 'Successfully added coupon.';
              return true;
            }
          }
        } else {
          this.validCoupon = false;
          this.validMessage = 'This is not a valid coupon code.';
          return false;
        }
      }
    },
    methods: {
      formatCurrency(number) {
        return parseFloat(number).toFixed(2);
      },
      applyCoupon() {
        if (this.couponInput.length > 0) {
          this.hasApplied = true;
          this.checkCoupon();
        } else {
          this.hasApplied = false;
          this.validMessage = 'Please enter a discount code.'
        }
      },
      checkCoupon() {
        this.$store.commit('SET_COUPON_ID', this.couponInput);
        this.$store.dispatch('CHECK_COUPON');
      },
      removeCoupon() {
        this.$store.commit('SET_COUPON_ID', '');
        this.$store.commit('SET_ACTIVE_COUPON', null);
        this.hasApplied = false;
        this.validCoupon = false;
        this.validMessage = '';
      }
    },
    watch: {
      couponInput: {
        handler() {
          if (!this.validCoupon) {
            this.hasApplied = false;
          }
        }
      }
    }
  }
</script>
